function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import utils from '@/js/utils';
import UserAccessObject from '@/views/tableau/UserAccessObject';
import UserAccessNew from '@/views/tableau/UserAccessNew';
import UserAccessLogs from '@/views/tableau/UserAccessLogs';
import UserAccessDetails from '@/views/tableau/UserAccessDetails';
import TableauUserAccessService from '@/apps/data-platform/services/visualization/tableauRol';
import tasks from '@/js/tasks';
export default {
  name: 'VisualizationUserAccess',
  components: {
    UserAccessObject: UserAccessObject,
    UserAccessNew: UserAccessNew,
    UserAccessLogs: UserAccessLogs,
    UserAccessDetails: UserAccessDetails
  },
  data: function data() {
    return {
      items: [],
      isBusy: false,
      modalName: 'Assign User',
      modalUserAccessObject: 'modalUserAccessObject',
      modalUserAccessNew: 'modalUserAccessNew',
      modalUserAccessLogs: 'modalUserAccessLogs',
      record: Object,
      expanded: [],
      pagination: {
        current: 1,
        limit: 10,
        offset: 0,
        total: 0
      }
    };
  },
  created: function created() {
    this.getItems();
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['isTableauMultipleAccess'])), {}, {
    fields: function fields() {
      return [{
        key: 'name',
        label: this.traductor('tablas.user'),
        class: 'w-30'
      }, {
        key: 'groups',
        label: this.traductor('tablas.groups'),
        class: 'w-50'
      }, {
        key: 'actions',
        label: this.traductor('tablas.actions'),
        class: 'w-20'
      }];
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.traductor('my_tasks.subtitle_visualization_access'),
        disabled: true
      }];
    },
    headers: function headers() {
      return [{
        value: 'name',
        text: this.traductor('tablas.user'),
        class: 'w-30'
      }, {
        value: 'groups',
        text: this.traductor('tablas.groups'),
        class: 'w-50',
        align: "left"
      }, {
        value: 'actions',
        text: this.traductor('tablas.actions'),
        class: 'w-20',
        align: "center"
      }];
    }
  }),
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    clickedRow: function clickedRow(value) {
      console.log(value);
      if (this.expanded.length && this.expanded[0].id == value.id) {
        this.expanded = [];
      } else {
        this.expanded = [];
        this.expanded.push(value);
      }
    },
    reload: function reload() {
      var params = {
        domain: window.userInfo.domain
      };
      TableauUserAccessService.reloadVisualizationUserAccess(params);
    },
    getItems: function getItems() {
      var _this = this;
      var params = {
        domain: window.userInfo.domain
      };
      this.isBusy = true;
      TableauUserAccessService.getVisualizationUserAccess(params).then(function (response) {
        _this.items = response.data.result;
      }).finally(function () {
        _this.isBusy = false;
      });
    },
    showModalUserAccessObject: function showModalUserAccessObject(data) {
      this.record = utils.cloneJSON(data.item);
      this.$refs[this.modalUserAccessObject].onOpen();
      //this.$root.$emit('bv::show::modal', this.modalUserAccessObject, '#btnShow')
    },
    showModalUserAccessNew: function showModalUserAccessNew(data) {
      var _this2 = this;
      this.record = utils.cloneJSON(data.item);
      // validar si solo debe tener multiples asignaciones
      if (this.isTableauMultipleAccess) {
        this.$refs[this.modalUserAccessNew].onOpen();
      } else {
        var params = {
          record: {
            document_id: this.record.name
          }
        };
        TableauUserAccessService.getTableauUserDP(params).then(function (response) {
          var items = response.data.result;
          if (items.length > 0) {
            tasks.toast.error('Solo puede asignar un usuario.');
          } else {
            _this2.$refs[_this2.modalUserAccessNew].onOpen();
          }
        });
      }
      //this.$root.$emit('bv::show::modal', this.modalUserAccessNew, '#btnShow')
    },
    showModalUserAccessLogs: function showModalUserAccessLogs(data) {
      this.record = utils.cloneJSON(data.item);
      this.$refs[this.modalUserAccessLogs].onOpen();
      //this.$root.$emit('bv::show::modal', this.modalUserAccessLogs, '#btnShow')
    },
    downloadMassive: function downloadMassive() {
      var _this3 = this;
      TableauUserAccessService.downloadTableauUserDP().then(function (response) {
        _this3.downloadAction({
          name: 'Visualization_User_Access'
        }, response.data);
      });
    },
    downloadData: function downloadData(data) {
      var _this4 = this;
      var params = {
        record: {
          document_id: data.name
        }
      };
      return TableauUserAccessService.downloadTableauUserDP(params).then(function (response) {
        _this4.downloadAction(data, response.data);
      });
    },
    downloadAction: function downloadAction() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Array;
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      var universalBOM = "\uFEFF";
      var url = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + body);
      a.href = url;
      a.download = "".concat(item.name, ".csv");
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }
};